var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { state } from 'lit/decorators.js';
import '@kodaris/krubble-components';
export class KRNavItemEdit extends LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.icon = '';
        this.url = '';
        this.active = true;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.data) {
            this.label = this.data.label || '';
            this.icon = this.data.icon || '';
            this.url = this.data.url || '';
            this.active = this.data.active !== false;
        }
    }
    handleLabelInput(e) {
        const textField = e.target;
        this.label = textField.value;
    }
    handleIconInput(e) {
        const textField = e.target;
        this.icon = textField.value;
    }
    handleUrlInput(e) {
        const textField = e.target;
        this.url = textField.value;
    }
    handleActiveChange(e) {
        this.active = e.target.checked;
    }
    handleCancel() {
        this.dialogRef.close(undefined);
    }
    handleSave() {
        this.dialogRef.close({
            label: this.label,
            icon: this.icon || undefined,
            url: this.url || undefined,
            active: this.active,
        });
    }
    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleSave();
        }
    }
    render() {
        return html `
      <h2>Edit Navigation Item</h2>

      <div class="form-group">
        <kr-text-field
          label="Label"
          name="label"
          .value=${this.label}
          @input=${this.handleLabelInput}
          @keydown=${this.handleKeyDown}
          placeholder="Enter label"
        ></kr-text-field>
      </div>

      <div class="form-group">
        <kr-text-field
          label="Icon (emoji or SVG)"
          name="icon"
          .value=${this.icon}
          @input=${this.handleIconInput}
          @keydown=${this.handleKeyDown}
          placeholder="e.g. 📊 or <svg>...</svg>"
        ></kr-text-field>
      </div>

      <div class="form-group">
        <kr-text-field
          label="URL"
          name="url"
          .value=${this.url}
          @input=${this.handleUrlInput}
          @keydown=${this.handleKeyDown}
          placeholder="e.g. /ci/my-page or https://..."
        ></kr-text-field>
      </div>

      <div class="form-group">
        <div class="checkbox-group">
          <input
            type="checkbox"
            id="active"
            .checked=${this.active}
            @change=${this.handleActiveChange}
          />
          <label class="checkbox-label" for="active">Visible in navigation</label>
        </div>
      </div>

      <div class="actions">
        <button class="btn-cancel" @click=${this.handleCancel}>Cancel</button>
        <button class="btn-save" @click=${this.handleSave}>Save</button>
      </div>
    `;
    }
}
KRNavItemEdit.styles = css `
    :host {
      display: block;
      width: 360px;
      padding: 24px;
      color: rgba(255, 255, 255, 0.9);

      /* Dark theme for kr-text-field */
      --kr-text-field-label-color: rgba(255, 255, 255, 0.7);
      --kr-text-field-border-color: rgba(255, 255, 255, 0.1);
      --kr-text-field-bg: rgba(255, 255, 255, 0.05);
      --kr-text-field-color: #ffffff;
      --kr-text-field-focus-border-color: #beea4e;
      --kr-text-field-focus-ring-color: rgba(190, 234, 78, 0.1);
      --kr-text-field-placeholder-color: rgba(255, 255, 255, 0.3);
      --kr-text-field-helper-color: rgba(255, 255, 255, 0.5);
    }

    h2 {
      margin: 0 0 24px 0;
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
    }

    .form-group {
      margin-bottom: 20px;
    }

    .checkbox-group {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      accent-color: #beea4e;
      cursor: pointer;
    }

    .checkbox-label {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      cursor: pointer;
    }

    .actions {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
      margin-top: 28px;
    }

    button {
      padding: 10px 20px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      font-family: inherit;
      cursor: pointer;
      transition: all 0.15s ease;
    }

    .btn-cancel {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.8);
    }

    .btn-cancel:hover {
      background: rgba(255, 255, 255, 0.1);
      color: #ffffff;
    }

    .btn-save {
      background: #beea4e;
      border: none;
      color: #10172a;
    }

    .btn-save:hover {
      background: #d4f472;
    }
  `;
__decorate([
    state()
], KRNavItemEdit.prototype, "label", void 0);
__decorate([
    state()
], KRNavItemEdit.prototype, "icon", void 0);
__decorate([
    state()
], KRNavItemEdit.prototype, "url", void 0);
__decorate([
    state()
], KRNavItemEdit.prototype, "active", void 0);
// Guarded registration: no-op if the tag is already defined, so a second copy of krubble on
// the page (e.g. the Operations shell loads krubble globally while an embedded app bundled its
// own copy) doesn't throw. First definition wins.
if (!customElements.get('kr-nav-item-edit')) {
    customElements.define('kr-nav-item-edit', KRNavItemEdit);
}
//# sourceMappingURL=nav-item-edit.js.map